// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/InventoryManagement/Inventoryproducts.module.css
// module id = 1238
// module chunks = 0